import React, { useEffect, useState } from 'react';
import FailureAlert from '../Common/Failure';
import Axiosfetch from '../Common/Axiosfetch';
import baseURL from '../Common/Config';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell } from '@fortawesome/free-solid-svg-icons';

const GetAlertTypeInfo = (alertType) => {
    switch (alertType) {
        case 1: return "green";
        case 2: return "#005582";
        case 3: return "red";
        default: return "green";
    }
};

const AlertType = [
    { label: "Success", value: 1 },
    { label: "Announcement / Info", value: 2 },
    { label: "Danger", value: 3 }
];

const UserAlerts = ({ hideUserAlertView }) => {
    const [Alerts, setAlerts] = useState([]);
    useEffect(() => {
        var userData = localStorage.getItem("userData") ? JSON.parse(localStorage.getItem("userData")) : null;
        Axiosfetch(baseURL + "GetAllAlertsByPartnerID", "POST", {
            PartnerID: userData.OrganizationID
        }, AlertSuccess, Failure);

    }, [])

    const AlertSuccess = (data) => {
        if (data.length > 0) {
            setAlerts(data);
        }
        else {
            setAlerts([]);
        }
    }

    const Failure = (err) => {
        FailureAlert(err);
    };

    return (
        <div id="userDirectory" className="modal" style={{ display: "block" }}>
            <div className="modal-content" style={{ height: "85%", padding: "0" }}>
                <div className="modal-header align-center mt-2 mb-2">
                    <h5 style={{ marginLeft: "5px", padding: "5px" }}>#mfimovers - Alerts</h5>
                    <span style={{ color: "black", marginRight: "0.3rem" }} className="close" onClick={hideUserAlertView}>&times;</span>
                </div>
                <div style={{ overflow: "auto", padding: "5px" }}>
                    <ul style={{ listStyle: "none", position: "relative" }}>
                        {Alerts && Alerts.length > 0 && Alerts.map((alert, index) => (
                            <li className='mb-3 d-flex' key={alert._id}>
                                <div className={`mr-2 ${Alerts.length !== (index + 1) ? "bell-style" : ""}`}><FontAwesomeIcon className='bell-css' style={{ color: "orange" }} icon={faBell}></FontAwesomeIcon></div>
                                <div>
                                    <div style={{ whiteSpace: "normal", textAlign: "left" }}>
                                        <span style={{ fontWeight: "600" }}>Type : </span><span style={{ color: GetAlertTypeInfo(alert.Type) }}>{AlertType[alert.Type - 1].label}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontWeight: "600" }}>Description : </span><span>{alert.AlertDesc}</span>
                                    </div>
                                    <div>
                                        <span style={{ fontWeight: "600" }}>Alert Date : </span><span>{moment(alert.StartDate).local().format("DD/MM/YYYY")}</span>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default UserAlerts;